// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"RP-z","carouselContainer":"SP-z"};